import React, { useState } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

const ProfileMenu = props => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("selected_student");
    localStorage.removeItem("student_selected");
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    localStorage.removeItem("primary_mail_id");
    localStorage.removeItem("userRole");
    localStorage.removeItem("email");
    localStorage.removeItem("role"); 
    localStorage.removeItem("activeTab");
    localStorage.removeItem("paymentResponse");
    localStorage.removeItem("selectedStudent");

    navigate("/logout");
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="bx bx-cog bx-spin" />
          <span className="d-none d-xl-inline-block ms-2 me-1">More</span> {/* {user.name} */}
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" href="/change-password">
            <i className="bx bx-key font-size-16 align-middle me-1" />
            {props.t("ChangePassword")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item" onClick={handleLogout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
